import { h } from 'preact';

type CustomTextAreaProps = {
  name: string;
  placeholder: string;
  label: string;
  type: string;
  validator?: string;
  value?: string;
};

const CustomTextArea = (props: CustomTextAreaProps) => {
  return (
    <div class="form-floating mb-3 form-group">
      <textarea
        type={props.type}
        class="form-control input"
        id={props.name}
        name={props.name}
        data-validator={props.validator || ''}
        placeholder={props.placeholder}
        value={props.value}
      />
      <label for={props.name}>{props.label}</label>
    </div>
  );
};

export default CustomTextArea;
